module.exports = __webpack_public_path__ + "img/blog-58 (1).93648160.jpg";